module.exports = __webpack_public_path__ + "img/7.75077ad4.png";